import { supabase } from "../supabaseClient";

// Consent types configured in Sales App -> Settings -> Customer Consent
export const CONSENT_TYPES = {
	TOKEN: "token",
	ALLOTMENT: "allotment",
	VIRTUAL_ACCOUNT: "virtual_account",
};

// One consent per type; no row means the customer is not asked for that type.
async function getConsentTemplate(type) {
	const { data, error } = await supabase
		.from("ConsentTemplates")
		.select("consentTemplateId, type, title, content")
		.eq("type", type)
		.limit(1);
	if (error) throw error;
	return data?.[0] || null;
}

async function hasCustomerConsent(leadId, type) {
	const { count, error } = await supabase
		.from("CustomerConsents")
		.select("customerConsentId", { count: "exact", head: true })
		.eq("leadId", leadId)
		.eq("consentType", type);
	if (error) throw error;
	return count > 0;
}

export async function saveCustomerConsent(obj) {
	const { data, error } = await supabase.from("CustomerConsents").insert([obj]);
	if (error) throw error;
	return data;
}

// ---- shared status so every screen (Pay Now, VA card, VA modal) agrees ----
// Only "accepted" is cached: the template itself is re-read so a consent
// added or deleted in the Sales App applies on the next click.
const accepted = new Set();
const listeners = new Set();
const key = (leadId, type) => `${leadId}:${type}`;

// Returns { template, required }. required = a consent exists for this type and this lead has not accepted it.
export async function getConsentStatus(leadId, type) {
	if (!leadId) return { template: null, required: false };
	if (accepted.has(key(leadId, type))) return { template: null, required: false };
	const template = await getConsentTemplate(type);
	if (!template) return { template: null, required: false };
	const done = await hasCustomerConsent(leadId, type);
	if (done) {
		accepted.add(key(leadId, type));
		return { template, required: false };
	}
	return { template, required: true };
}

export function markConsentAccepted(leadId, type) {
	accepted.add(key(leadId, type));
	listeners.forEach((fn) => fn(leadId, type));
}

export function subscribeConsent(fn) {
	listeners.add(fn);
	return () => listeners.delete(fn);
}
